/* ===========================================================================
   BICY — motion engine + commerce (vanilla, zero dipendenze)
   Portabile su Shopify: sostituire solo il blocco CART con l'AJAX Cart API.
   =========================================================================== */
(function () {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const WA = '393519906159';
  const lerp = (a, b, t) => a + (b - a) * t;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const euro = n => Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' \u20AC';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const base = () => '/';
  var UPSELL = [];                    // popolata più sotto da #upsell

  /* ---------------------------------------------------------------- TEMA */
  const root = document.documentElement;
  const isLight = () => root.getAttribute('data-theme') === 'light';

  function applyTheme(t, save) {
    root.setAttribute('data-theme', t);
    if (save !== false) { try { localStorage.setItem('bicy-theme', t); } catch (e) {} }
    const meta = $('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', t === 'light' ? '#FFFFFF' : '#08080A');
    $$('[data-theme-toggle]').forEach(b => {
      b.setAttribute('aria-label', t === 'light' ? 'Passa al tema scuro' : 'Passa al tema chiaro');
    });
    if (anatImg) { anatImg.dataset.cur = ''; anatomy(); }
  }
  $$('[data-theme-toggle]').forEach(b => b.addEventListener('click', () => {
    applyTheme(isLight() ? 'dark' : 'light');
  }));
  // il tema di default e' il chiaro (impostato prima del paint): cambia solo con lo switch

  /* ---------------------------------------------------------------- SPLIT TEXT */
  // Avvolge ogni parola in .word > span per la rivelazione mascherata.
  function split(el) {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    const walk = node => {
      [...node.childNodes].forEach(n => {
        if (n.nodeType === 3 && n.textContent.trim()) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(w => {
            if (!w.trim()) return frag.appendChild(document.createTextNode(' '));
            const o = document.createElement('span'); o.className = 'word';
            const i = document.createElement('span'); i.textContent = w;
            o.appendChild(i); frag.appendChild(o);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && !n.classList.contains('word')) walk(n);
      });
    };
    walk(el);
    $$('.word > span', el).forEach((s, i) => { s.style.transitionDelay = (i * 45) + 'ms'; });
  }
  if (!reduced) $$('[data-split]').forEach(split);

  /* ---------------------------------------------------------------- REVEAL */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('in');
    $$('.clip', e.target).forEach(c => c.classList.add('in'));   // i .clip sono osservati tramite il genitore
    io.unobserve(e.target);
  }), { threshold: .1, rootMargin: '0px 0px -8%' });
  // i .clip (clip-path) non intersecano in modo affidabile: si osserva il genitore
  $$('.rv,.clip,[data-split],.mask').forEach(el => io.observe(el.classList.contains('clip') && el.parentElement ? el.parentElement : el));
  // rete di sicurezza: cio' che e' gia' nello schermo viene mostrato anche se l'observer tarda
  // (ripristino da bfcache, scroll gia' avvenuto, primo paint lento)
  const revealVisible = () => $$('.rv,.clip,[data-split],.mask').forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.top < innerHeight * 1.15 && r.bottom > -40) el.classList.add('in');
  });
  setTimeout(revealVisible, 400); setTimeout(revealVisible, 2500);
  addEventListener('pageshow', revealVisible);

  /* ---------------------------------------------------------------- PARALLAX + rAF loop */
  const pars = (fine ? $$('[data-par]') : []).map(el => ({ el, sp: parseFloat(el.dataset.par) || .12, y: 0, t: 0 }));
  let anatVisible = false;
  function frame() {
    const vh = innerHeight;
    pars.forEach(p => {
      const r = p.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      p.t = (r.top + r.height / 2 - vh / 2) * -p.sp;
      p.y = lerp(p.y, p.t, .12);
      p.el.style.transform = `translate3d(0,${p.y.toFixed(2)}px,0)`;
    });
    if (anatVisible) anatomy();
    requestAnimationFrame(frame);
  }

  /* ---------------------------------------------------------------- HEADER */
  const header = $('.header');
  // altezza reale dell'header (ticker + nav) esposta come variabile CSS
  const setHeadH = () => {
    if (!header) return;
    // l'altezza dell'header non cambia in scroll (il ticker viene traslato, non chiuso): misura diretta, senza toccare classi
    document.documentElement.style.setProperty('--head-h', header.offsetHeight + 'px');
    document.documentElement.style.setProperty('--nav-h-real', ($('.nav') ? $('.nav').offsetHeight : 76) + 'px');
  };
  setHeadH();
  // solo i resize di larghezza: la barra URL del telefono cambia solo l'altezza e non deve rimisurare nulla
  let lastW = innerWidth;
  addEventListener('resize', () => { if (innerWidth !== lastW) { lastW = innerWidth; setHeadH(); } });
  if (header) {
    // "solid" appena si scorre (6px), torna trasparente solo tornando in cima (< 2px):
    // piccola isteresi contro il tremolio sulla soglia e il rimbalzo elastico di iOS.
    const setSolid = y => {
      const solid = header.classList.contains('solid');
      if (!solid && y > 6) header.classList.add('solid');
      else if (solid && y < 2) header.classList.remove('solid');
    };
    setSolid(scrollY);
    // sentinella in cima: aggiorna anche quando lo scroll arriva senza eventi (ripristino pagina, ancore)
    const sent = document.createElement('i');
    sent.className = 'head-sentinel';
    document.body.prepend(sent);
    // l'observer e' solo una sveglia: decide sempre setSolid con la posizione reale (isteresi 6/2 rispettata)
    new IntersectionObserver(() => setSolid(Math.max(scrollY, 0)), { threshold: 0 }).observe(sent);

    // un solo controllo per frame; auto-hide solo per movimenti reali (> 8px) fatti dall'utente
    let lastY = scrollY, ticking = false;
    let quiet = performance.now() + 1200;   // primo secondo: ripristino scroll, ancore, bfcache → niente auto-hide
    const setHide = on => { header.classList.toggle('hide', on); document.body.classList.toggle('head-hidden', on); };
    const calm = () => { quiet = performance.now() + 1200; setHide(false); };
    addEventListener('scroll', () => {
      setSolid(scrollY);                 // sincrono: costa nulla e non dipende dal rAF
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const max = Math.max(document.documentElement.scrollHeight - innerHeight, 0);
        const y = Math.min(Math.max(scrollY, 0), max), d = y - lastY;   // clamp: niente falsi movimenti dal rimbalzo iOS
        if (Math.abs(d) > 8) {
          if (performance.now() > quiet) setHide(d > 0 && y > 560 && !$('.overlay.on'));
          lastY = y;
        }
        ticking = false;
      });
    }, { passive: true });
    addEventListener('hashchange', calm);
    document.addEventListener('click', e => { if (e.target.closest('a[href*="#"]')) calm(); }, true);
    addEventListener('pageshow', () => { setHide(false); lastY = scrollY; calm(); setSolid(scrollY); });
  }

  /* ---------------------------------------------------------------- WHATSAPP: compare solo dopo il primo scroll */
  const fab = $('.wa-fab');
  if (fab) {
    let fabHid = null, onFoot = false;
    const updFab = () => { const h = scrollY < 40 || onFoot || document.body.classList.contains('head-hidden'); if (h !== fabHid) { fabHid = h; fab.classList.toggle('hid', h); } };
    updFab();
    addEventListener('scroll', updFab, { passive: true });
    new MutationObserver(updFab).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    const foot = $('.footer');
    if (foot) new IntersectionObserver(es => { onFoot = es[0].isIntersecting; updFab(); }, { rootMargin: '0px 0px -40px 0px' }).observe(foot);
  }

  /* ---------------------------------------------------------------- PRELOADER */
  // Progresso legato al caricamento reale con fallback: mai bloccante.
  const loader = $('.loader');
  let seen = false; try { seen = sessionStorage.getItem('bicy-seen') === '1'; } catch (e) {}
  if (loader && seen) { loader.remove(); document.body.classList.remove('locked'); }
  else if (loader) {
    const bar = $('.bar i', loader), pct = $('.pct', loader);
    const t0 = performance.now();
    let loaded = document.readyState === 'complete', done = false;
    addEventListener('load', () => { loaded = true; });
    const finish = () => {
      if (done) return; done = true;
      loader.classList.add('done');
      document.body.classList.remove('locked');
      try { sessionStorage.setItem('bicy-seen', '1'); } catch (e) {}
      const h = $('.hero');
      if (h) { h.classList.add('in'); $$('[data-split],.mask,.rv', h).forEach(e => e.classList.add('in')); }
    };
    const tick = now => {
      const el = now - t0;
      // avanza fino al 90% in 1.2s, poi aspetta il load (max 3.2s totali)
      const p = Math.min(loaded || el > 1800 ? 100 : 92, el / 700 * 92);
      bar.style.width = p + '%';
      pct.textContent = String(Math.round(p)).padStart(3, '0');
      if (p >= 100) return setTimeout(finish, 220);
      requestAnimationFrame(tick);
    };
    // se la pagina non e' visibile (tab in background) rAF non gira: niente loader bloccante
    if (reduced || document.visibilityState === 'hidden') finish();
    else requestAnimationFrame(tick);
    setTimeout(finish, 2600);   // rete di sicurezza
  }

  if (!$('.loader')) {
    const h = $('.hero');
    if (h) requestAnimationFrame(() => { h.classList.add('in'); $$('[data-split],.mask,.rv', h).forEach(e => e.classList.add('in')); });
  }

  /* ---------------------------------------------------------------- PAGE TRANSITION */
  const curtain = $('.curtain');
  if (curtain && !reduced && fine) {
    document.addEventListener('click', e => {
      const a = e.target.closest('a[href]');
      if (!a) return;
      const href = a.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('http') || href.startsWith('tel') ||
          href.startsWith('mailto') || a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      // ancora nella stessa pagina (index.html#confronto da / o da /index.html): navigazione nativa, niente sipario
      const u = new URL(a.href, location.href);
      const norm = p => p.replace(/\/index\.html$/, '/');
      if (norm(u.pathname) === norm(location.pathname) && u.search === location.search && u.hash) return;
      e.preventDefault();
      curtain.classList.add('on');
      setTimeout(() => { location.href = href; }, 240);
    });
    addEventListener('pageshow', () => curtain.classList.remove('on'));   // ritorno da bfcache: sipario via
  }

  /* ---------------------------------------------------------------- VIDEO HERO */
  const hv = $('.hero-video');
  if (hv) {
    if (innerWidth >= 900 && hv.dataset.widePoster) hv.poster = hv.dataset.widePoster;
    if (reduced) { hv.pause(); hv.removeAttribute('autoplay'); }
    else {
      hv.play().catch(() => {});   // se il browser blocca l'autoplay resta il poster
      new IntersectionObserver(es => es.forEach(e => {
        if (e.isIntersecting) hv.play().catch(() => {}); else hv.pause();
      }), { threshold: .01 }).observe(hv);
    }
  }

  /* ---------------------------------------------------------------- MENU OVERLAY */
  const ov = $('.overlay');
  $$('[data-menu]').forEach(b => b.addEventListener('click', () => {
    const on = ov.classList.toggle('on');
    document.body.classList.toggle('locked', on);
    const mb = $('.menu-btn'); if (mb) mb.classList.toggle('x', on);
    $$('.ov-links a', ov).forEach((a, i) => { a.style.transitionDelay = on ? (120 + i * 70) + 'ms' : '0ms'; });
  }));
  const closeMenu = () => {
    if (!ov) return;
    ov.classList.remove('on'); document.body.classList.remove('locked');
    const mb = $('.menu-btn'); if (mb) mb.classList.remove('x');
  };
  // un link del menu verso un'ancora della stessa pagina non ricarica: il menu va chiuso a mano
  if (ov) $$('.ov-links a', ov).forEach(a => a.addEventListener('click', () => { if (ov.classList.contains('on')) closeMenu(); }));

  /* ---------------------------------------------------------------- MODEL LIST PREVIEW */
  const prev = $('.mprev');
  if (prev && fine) {
    let px = 0, py = 0, tx2 = 0, ty2 = 0, active = false;
    $$('.mrow').forEach(row => {
      row.addEventListener('mouseenter', () => {
        active = true; prev.classList.add('on');
        $$('img', prev).forEach(i => i.classList.toggle('on', i.dataset.for === row.dataset.slug));
      });
      row.addEventListener('mouseleave', () => { active = false; prev.classList.remove('on'); });
    });
    addEventListener('mousemove', e => { tx2 = e.clientX; ty2 = e.clientY; });
    (function loop() {
      px = lerp(px, tx2, .1); py = lerp(py, ty2, .1);
      if (active) prev.style.transform = `translate(${px}px,${py}px) translate(-50%,-50%) rotate(${clamp((tx2 - px) * .12, -8, 8)}deg)`;
      requestAnimationFrame(loop);
    })();
  }

  /* ---------------------------------------------------------------- ANATOMIA (scroll pinned) */
  const anat = $('.anat');
  const steps = $$('.astep');
  const rail = $('.anat-rail i');
  const anatImg = $('.anat-media img');
  function anatomy() {
    if (!anat || !steps.length) return;
    const mid = innerHeight * .45;
    let idx = 0;
    steps.forEach((s, i) => { const r = s.getBoundingClientRect(); if (r.top <= mid) idx = i; });
    steps.forEach((s, i) => s.classList.toggle('on', i === idx));
    const st = $('.anat-steps').getBoundingClientRect();
    const prog = clamp((mid - st.top) / st.height, 0, 1);
    if (rail) {                       // scrittura solo se cambia: niente layout inutili per frame
      const h = (prog * 100).toFixed(1) + '%';
      if (rail.dataset.h !== h) { rail.dataset.h = h; rail.style.height = h; }
    }
    const st2 = steps[idx];
    const src = st2 && (isLight() ? (st2.dataset.imgLight || st2.dataset.img) : st2.dataset.img);
    if (anatImg && src && anatImg.dataset.cur !== src) {
      anatImg.dataset.cur = src;
      anatImg.style.opacity = '0';
      setTimeout(() => { anatImg.src = src; anatImg.style.opacity = '1'; }, 180);
    }
  }
  if (anatImg) anatImg.style.transition = 'opacity .4s ease, transform 1.2s cubic-bezier(.19,1,.22,1)';

  // La sezione "Anatomia" lavora solo quando e' davvero in vista.
  if (anat) new IntersectionObserver(([e]) => {
    anatVisible = e.isIntersecting;
    if (anatVisible) anatomy();
  }, { rootMargin: '15% 0px' }).observe(anat);

  if (!reduced && pars.length) requestAnimationFrame(frame);   // rAF continuo: solo il parallax desktop
  else if (anat) {
    // mobile: nessun loop a vuoto, un solo calcolo per frame e solo mentre la sezione e' a schermo
    let queued = false;
    addEventListener('scroll', () => {
      if (queued || !anatVisible) return;
      queued = true;
      requestAnimationFrame(() => { anatomy(); queued = false; });
    }, { passive: true });
  }

  /* ---------------------------------------------------------------- COUNTERS */
  const cio = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target, to = parseFloat(el.dataset.count), suf = el.dataset.suffix || '';
    const dur = 1400, t0 = performance.now();
    (function step(t) {
      const k = clamp((t - t0) / dur, 0, 1);
      const v = to * (1 - Math.pow(1 - k, 3));
      el.textContent = (to % 1 ? v.toFixed(1) : Math.round(v).toLocaleString('it-IT')) + suf;
      if (k < 1) requestAnimationFrame(step);
    })(t0);
    cio.unobserve(el);
  }), { threshold: .6 });
  $$('[data-count]').forEach(el => cio.observe(el));


  /* ---------------------------------------------------------------- CART (Shopify AJAX Cart API) */
  let cart = [];                       // righe del carrello Shopify, gia' nel formato usato dal cassetto
  const drawer = $('.drawer'), scrim = $('.scrim');
  /* ---- codice fiscale: salvato come attributo dell'ordine (compare nei Dettagli aggiuntivi) ---- */
  const CF_KEY = 'bicy_cf';
  const cfEl = () => $('[data-cf]');
  const cfClean = v => String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 16);
  const cfValid = v => /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/.test(v) || /^\d{11}$/.test(v);   // codice fiscale o partita IVA
  async function cfSave(v) {
    try { localStorage.setItem(CF_KEY, v); } catch (e) {}
    try { await fetch('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ attributes: { 'Codice fiscale': v } }) }); } catch (e) {}
  }
  (function cfInit() {
    const el = cfEl(); if (!el) return;
    try { el.value = localStorage.getItem(CF_KEY) || ''; } catch (e) {}
    const hint = el.parentElement.querySelector('.cf-hint');
    el.addEventListener('input', () => { el.value = cfClean(el.value); el.classList.remove('bad'); if (hint) { hint.classList.remove('bad'); hint.textContent = 'Serve per la fattura'; } });
    el.addEventListener('blur', () => {
      const v = cfClean(el.value);
      if (v && !cfValid(v)) { el.classList.add('bad'); if (hint) { hint.classList.add('bad'); hint.textContent = 'Controlla: 16 caratteri (o 11 cifre per la partita IVA)'; } return; }
      cfSave(v);
    });
    /* prima di andare al checkout salva il codice sull'ordine */
    $$('[data-wa-checkout]').forEach(a => a.addEventListener('click', async ev => {
      const v = cfClean(el.value);
      if (!v || !cfValid(v)) return;                 // vuoto o non valido: si prosegue senza
      ev.preventDefault();
      await cfSave(v);
      location.href = a.getAttribute('href') || '/checkout';
    }));
  })();
  const open = () => { drawer.classList.add('on'); scrim.classList.add('on'); document.body.classList.add('locked'); };
  const close = () => { drawer.classList.remove('on'); scrim.classList.remove('on'); document.body.classList.remove('locked'); };
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', open));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', close));
  scrim && scrim.addEventListener('click', close);
  addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    close();
    if (ov && ov.classList.contains('on')) closeMenu();
  });

  let tt;
  function toast(msg) {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3DDC97" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg>' + msg;
    requestAnimationFrame(() => t.classList.add('on'));
    clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 2600);
  }

  const ckey = i => i.key;
  const J = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  const fromShopify = c => (c.items || []).map(it => ({
    key: it.key, id: it.variant_id, handle: it.handle, name: it.product_title,
    variant: it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '',
    price: it.price / 100, qty: it.quantity,
    img: it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_300x300$1$2') : ''
  }));
  async function refresh() {
    try { const r = await fetch('/cart.js', { headers: J }); cart = fromShopify(await r.json()); } catch (e) {}
    render();
  }

  function rowNode(i) {
    const el = document.createElement('div');
    el.className = 'ci';
    el.dataset.key = ckey(i);
    el.dataset.vid = i.id;
    el.innerHTML = `
        <img src="${i.img}" alt="" loading="lazy">
        <div>
          <b>${i.name}</b>
          ${i.variant ? `<small>${i.variant}</small>` : ''}
          <div class="qty"><button data-dec aria-label="Riduci">−</button><span>${i.qty}</span><button data-inc aria-label="Aumenta">+</button></div>
          <button class="rm" data-del>rimuovi</button>
        </div>
        <b class="ci-tot" style="font-family:var(--f-display)">${euro(i.price * i.qty)}</b>`;
    return el;
  }

  function render() {
    const body = $('.d-body'); if (!body) return;
    const n = cart.reduce((s, i) => s + i.qty, 0);
    $$('.cart-btn .n').forEach(c => c.textContent = n);
    if (!cart.length) {
      if (!$('.empty', body)) body.innerHTML = `<div class="empty">Il carrello è vuoto.<br><br><a class="btn btn-sm" href="/pages/e-bike"><span>Scopri le e-bike</span></a></div>`;
    } else {
      const empty = $('.empty', body); if (empty) empty.remove();
      const have = new Map([...body.children].filter(c => c.dataset && c.dataset.key).map(c => [c.dataset.key, c]));
      cart.forEach((i, idx) => {
        const k = ckey(i);
        let el = have.get(k);
        if (!el) {   // riga provvisoria della stessa variante: la riuso, niente sfarfallio
          const tmp = [...have.values()].find(c => c.dataset.key.startsWith('tmp-') && c.dataset.vid === String(i.id));
          if (tmp) { have.delete(tmp.dataset.key); tmp.dataset.key = k; el = tmp; }
        }
        if (el) {
          have.delete(k);
          const q = $('.qty span', el); if (q.textContent !== String(i.qty)) q.textContent = i.qty;
          const t = $('.ci-tot', el), v = euro(i.price * i.qty); if (t.textContent !== v) t.textContent = v;
        } else {
          el = rowNode(i); el.classList.add('ci-new');
          requestAnimationFrame(() => el.classList.remove('ci-new'));
        }
        if (body.children[idx] !== el) body.insertBefore(el, body.children[idx] || null);
      });
      have.forEach(el => el.remove());
    }
    const tot = cart.reduce((s, i) => s + i.price * i.qty, 0);
    const el = $('[data-total]'); if (el) el.textContent = euro(tot);
    if (typeof paintUpsell === 'function') paintUpsell();
  }

  const vcache = {};
  async function resolveVariant(handle, color) {
    if (!handle) return null;
    if (!vcache[handle]) { try { vcache[handle] = await (await fetch(`/products/${handle}.js`, { headers: J })).json(); } catch (e) { return null; } }
    const p = vcache[handle]; if (!p || !p.variants) return null;
    const v = (color && p.variants.find(x => String(x.option1 || x.title).toLowerCase() === String(color).toLowerCase()))
           || p.variants.find(x => x.available) || p.variants[0];
    return v && v.id;
  }
  async function addToCart(it, qty) {
    let vid = it.id && /^\d{10,}$/.test(String(it.id)) ? +it.id : null;   // id di variante Shopify (13 cifre), non gli id vecchi
    if (!vid) vid = await resolveVariant(it.handle, it.variant);
    if (!vid) { toast('Prodotto non disponibile'); return; }
    const same = cart.find(c => String(c.id) === String(vid));
    if (same) same.qty += (qty || 1);
    else cart.push({ key: 'tmp-' + vid, id: vid, handle: it.handle, name: it.name, variant: it.variant || '', price: +it.price || 0, qty: qty || 1, img: it.img || '' });
    render();
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: [{ id: vid, quantity: qty || 1 }] }) });
      if (!r.ok) { toast('Non disponibile in questa quantità'); }
    } catch (e) { toast('Errore di rete, riprova'); }
    await refresh();
  }
  async function changeQty(key, quantity) {
    const it = cart.find(c => c.key === key);
    if (it) { it.qty = quantity; if (!quantity) cart = cart.filter(c => c !== it); render(); }
    try { await fetch('/cart/change.js', { method: 'POST', headers: J, body: JSON.stringify({ id: key, quantity }) }); } catch (e) {}
    await refresh();
  }

  document.addEventListener('click', e => {
    const q = e.target.closest('[data-quick]');
    if (q) {
      e.preventDefault(); e.stopPropagation();
      const d = q.closest('.card').dataset;
      const colors = (d.colors || '').split('|').filter(Boolean);
      let imgs = {}; try { imgs = JSON.parse(d.imgs || '{}'); } catch (e2) {}
      const sw = {}; $$('.dots .dot', q.closest('.card')).forEach(x => { if (x.title) sw[x.title] = x.style.background; });
      const it = { id: '', handle: d.handle || (d.href || '').split('/products/')[1], name: d.name, price: +d.price, img: d.img, imgs, sw, sub: d.sub,
                   colors, variant: colors[0] || '', qty: 1 };
      if (colors.length > 1 && sheet) { sItem = it; paintSheet(); sheetOpen(); }
      else { addToCart(it, 1).then(() => { open(); toast('Aggiunto al carrello'); }); }
      return;
    }
    const b = e.target.closest('[data-add]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      const sel = $('.opt button.on');
      const cols = (b.dataset.colors || '').split('|').filter(Boolean);
      if (cols.length > 1 && sheet && !sel) {          // piu' colori e nessuna scelta in pagina: chiedo il colore
        let imgs = {}; try { imgs = JSON.parse(b.dataset.imgs || '{}'); } catch (e2) {}
        sItem = { id: '', handle: b.dataset.handle, name: b.dataset.name, price: +b.dataset.price, img: b.dataset.img, imgs,
                  sub: b.dataset.sub || '', colors: cols, variant: cols[0], qty: 1 };
        paintSheet(); sheetOpen(); return;
      }
      addToCart({ id: b.dataset.add, handle: b.dataset.handle, name: b.dataset.name, price: b.dataset.price, img: b.dataset.img,
                  variant: b.dataset.variant || (sel ? sel.dataset.color : '') }, 1).then(() => { open(); toast('Aggiunto al carrello'); });
      return;
    }
    const d = e.target.closest('[data-dec]'), i = e.target.closest('[data-inc]'), x = e.target.closest('[data-del]');
    const row = (d || i || x) && (d || i || x).closest('.ci');
    if (row) {
      const it = cart.find(c => ckey(c) === row.dataset.key); if (!it) return;
      changeQty(it.key, d ? it.qty - 1 : i ? it.qty + 1 : 0);
    }
  }, true);
  refresh();
  applyTheme(root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light', false);

  /* ---------------------------------------------------------------- FILTRI */
  // su mobile la prima card visibile va a tutta larghezza (vetrina)
  function markFirst() {
    $$('.grid.showcase').forEach(g => {
      const cards = $$('.card', g);
      cards.forEach(c => c.classList.remove('wide-first'));
      const first = cards.find(c => c.style.display !== 'none');
      if (first) first.classList.add('wide-first');
    });
  }
  markFirst();

  const fbar = $('[data-filters]');
  if (fbar) {
    const thumb = $('.fb-thumb', fbar);
    const count = $('[data-fcount]');

    const moveThumb = () => {
      const on = $('.chip.on', fbar);
      if (!on || !thumb) return;
      thumb.style.width = on.offsetWidth + 'px';
      thumb.style.transform = `translateX(${on.offsetLeft}px)`;   // allineato al chip, niente sbordo
    };
    // alla prima passata niente animazione
    thumb.style.transition = 'none';
    requestAnimationFrame(() => {
      moveThumb();
      requestAnimationFrame(() => { thumb.style.transition = ''; });
    });
    addEventListener('resize', moveThumb);
    document.fonts && document.fonts.ready.then(moveThumb);

    $$('.chip[data-filter]', fbar).forEach(c => c.addEventListener('click', () => {
      $$('.chip[data-filter]', fbar).forEach(o => o.classList.remove('on'));
      c.classList.add('on');
      moveThumb();
      c.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      applyFilter(c.dataset.filter, fbar.closest('section') || document, count);
    }));
  }

  function applyFilter(f, scope, count) {
    let n = 0;
    $$('[data-tags]', scope).forEach(el => {
      const show = f === 'all' || el.dataset.tags.split(' ').includes(f);
      if (show) n++;
      el.style.transition = 'opacity .35s, transform .35s';
      el.style.opacity = show ? '1' : '0';
      el.style.transform = show ? 'none' : 'scale(.97)';
      setTimeout(() => {
        el.style.display = show ? '' : 'none'; markFirst();
        $$('.hscroll', scope).forEach(h => { h.scrollLeft = 0; });
        $$('.hscroll').forEach(h => h.__hsSync && h.__hsSync());
      }, show ? 0 : 340);
    });
    if (count) {
      const unit = count.dataset.unit || 'modelli';
      count.textContent = n + ' ' + (n === 1 ? unit.replace(/i$/, 'o') : unit);
    }
  }

  // filtri a tendina (pagine e-bike e accessori): tipo + ordine per prezzo
  $$('[data-filter-select]').forEach(sel => {
    const scope = sel.closest('section') || document;
    sel.addEventListener('change', () => applyFilter(sel.value, scope, $('[data-fcount]', scope)));
  });
  $$('[data-sort-select]').forEach(sel => {
    const scope = sel.closest('section') || document;
    const grid = $('.grid', scope); if (!grid) return;
    const orig = [...grid.children];
    sel.addEventListener('change', () => {
      const list = sel.value ? [...grid.children].sort((a, b) => (+a.dataset.price - +b.dataset.price) * (sel.value === 'desc' ? -1 : 1)) : orig;
      list.forEach(el => grid.appendChild(el));
      markFirst();
    });
  });

  // tessere "scegli per come pedali": applicano il filtro corrispondente alla griglia
  $$('[data-pick-filter]').forEach(a => a.addEventListener('click', () => {
    const sel = $('[data-filter-select]');
    if (sel) { sel.value = a.dataset.pickFilter; sel.dispatchEvent(new Event('change')); return; }
    const chip = $(`[data-filters] .chip[data-filter="${a.dataset.pickFilter}"]`);
    if (chip) chip.click();
  }));

  /* ---------------------------------------------------------------- PDP */
  const main = $('.gal .main img');
  const mainBox = main && main.closest('.main');
  const small = src => src.includes('/bikes/') ? src.replace('.jpg', '-sm.jpg') : src;   // miniature leggere
  const setOf = full => (full !== small(full) ? `${small(full)} 700w, ${full} 1400w` : '');
  const headH = () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--head-h')) || 70;

  // precarica le foto della galleria con le stesse candidate della foto grande: il cambio e' istantaneo
  const warmed = new Set();
  function warm(list) {
    list.forEach(full => {
      if (!full || warmed.has(full)) return;
      warmed.add(full);
      const im = new Image();
      if (main && main.sizes) im.sizes = main.sizes;
      const ss = setOf(full); if (ss) im.srcset = ss;
      im.src = full;
    });
  }
  // cambio foto: decodifico la nuova fuori schermo e la mostro solo quando e' pronta (niente vuoto, niente scatto)
  function swapMain(full) {
    if (!main || !full) return;
    const im = new Image();
    if (main.sizes) im.sizes = main.sizes;
    const ss = setOf(full); if (ss) im.srcset = ss;
    im.src = full;
    main.dataset.full = full;
    main.style.opacity = '.4';
    (im.decode ? im.decode().catch(() => {}) : Promise.resolve()).then(() => {
      if (main.dataset.full !== full) return;     // nel frattempo e' stata scelta un'altra foto
      main.srcset = ss; main.src = full; main.style.opacity = '1';
    });
  }
  if (main) {
    main.style.transition = 'opacity .16s ease';
    main.dataset.full = main.getAttribute('src');
    main.style.cursor = 'zoom-in';
    bindThumbs();
    const warmAll = () => warm($$('.gal .thumbs img').map(t => t.dataset.full || t.src));
    if (document.readyState === 'complete') setTimeout(warmAll, 300); else addEventListener('load', () => setTimeout(warmAll, 300));
  }
  $$('.opt button').forEach(b => b.addEventListener('click', () => {
    $$('.opt button').forEach(o => o.classList.remove('on'));
    b.classList.add('on');
    const l = $('[data-color-label]'); if (l) l.textContent = b.dataset.color;
    // Family Bike: ogni versione ha prezzo, descrizione e specifiche suoi
    if (b.dataset.price) {
      const pr = String(Math.round(+b.dataset.price)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';   // 1.200 € come nel resto del sito
      $$('[data-add]').forEach(a => { a.dataset.price = b.dataset.price; });
      $$('.buy [data-add] span').forEach(sp => { sp.textContent = 'Aggiungi al carrello — ' + pr; });
      const sb = $('.sticky-buy .sb b'); if (sb) sb.textContent = pr;
    }
    $$('[data-vpane]').forEach(el => {
      const on = el.dataset.vpane === b.dataset.color;
      el.hidden = !on;
      if (on) { el.classList.add('in'); $$('.rv,.clip', el).forEach(r => r.classList.add('in')); }
    });
    // il colore cambia anche la galleria: prime immagini = ritagli di quel colore
    let g = [];
    try { g = JSON.parse(b.dataset.gallery || '[]'); } catch (e) {}
    if (!g.length) return;
    const thumbs = $('.gal .thumbs');
    if (thumbs) thumbs.innerHTML = g.slice(0, 16).map((src, i) =>
      `<img src="${small(src)}" data-full="${src}" class="${i ? '' : 'on'}" alt="" loading="lazy" decoding="async">`).join('');
    swapMain(g[0]);
    warm(g.slice(0, 16));
    bindThumbs();
    // anche il pulsante carrello porta l'immagine giusta
    $$('[data-add]').forEach(a => { if (a.dataset.img) a.dataset.img = g[0]; });
    // e la pagina torna sulla foto, cosi' il colore scelto si vede subito
    if (mainBox) {
      const r = mainBox.getBoundingClientRect();
      if (r.top < headH() + 4 || r.bottom > innerHeight) scrollTo({ top: scrollY + r.top - headH() - 10, behavior: 'smooth' });
    }
  }));

  function bindThumbs() {
    $$('.gal .thumbs img').forEach((t, i, all) => {
      t.tabIndex = 0; t.setAttribute('role', 'button'); t.setAttribute('aria-label', `Foto ${i + 1} di ${all.length}`);
      t.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); } });
    });
    $$('.gal .thumbs img').forEach(t => t.addEventListener('click', () => {
      $$('.gal .thumbs img').forEach(o => o.classList.remove('on'));
      t.classList.add('on');
      swapMain(t.dataset.full || t.src);
    }));
  }

  /* ---------------------------------------------------------------- LENTE: foto grande a schermo intero, zoom leggero */
  // un tocco sulla foto la apre; un tocco sulla foto aperta la ingrandisce (max 1.75x, si trascina con il dito), un altro la riporta a misura
  /* scorrere con il dito tra le foto: sulla foto grande e nella lente */
  function stepPhoto(dir) {
    const th = $$('.gal .thumbs img'); if (th.length < 2) return false;
    let i = th.findIndex(t => t.classList.contains('on')); if (i < 0) i = 0;
    const n = (i + dir + th.length) % th.length;
    th[n].click();
    if (lb && lb.classList.contains('on')) {
      const im = $('img', lb); im.removeAttribute('srcset'); im.src = th[n].dataset.full || th[n].src;
      lb.classList.remove('zoom'); lb.scrollTop = 0; lb.scrollLeft = 0;
    }
    return true;
  }
  function swipePhotos(el, allowed) {
    let x0 = null, y0 = 0;
    el.addEventListener('touchstart', e => {
      if (e.touches.length !== 1 || (allowed && !allowed())) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    el.addEventListener('touchend', e => {
      if (x0 === null) return;
      const t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3 && stepPhoto(dx < 0 ? 1 : -1)) el.__swiped = Date.now();
    }, { passive: true });
    // il tocco che chiude uno swipe non deve aprire la lente o zoomare
    el.addEventListener('click', e => { if (el.__swiped && Date.now() - el.__swiped < 450) { e.stopImmediatePropagation(); e.preventDefault(); } }, true);
  }
  if (mainBox) swipePhotos(mainBox);

  let lb = null;
  const VERB = matchMedia('(hover:hover)').matches ? 'Clicca' : 'Tocca';
  function closeLb() {
    if (!lb) return;
    lb.classList.remove('on', 'zoom');
    document.body.classList.remove('locked');
  }
  function openLb() {
    if (!main) return;
    const full = main.dataset.full || main.getAttribute('src');
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'lb';
      lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-label', 'Foto a schermo intero');
      lb.innerHTML = '<div class="lb-stage"><img alt="" decoding="async"></div>' +
        '<button class="lb-x" type="button" aria-label="Chiudi"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '<span class="lb-hint"></span>';
      document.body.appendChild(lb);
      swipePhotos(lb, () => !lb.classList.contains('zoom'));
      const img = $('img', lb), hint = $('.lb-hint', lb);
      $('.lb-x', lb).addEventListener('click', closeLb);
      lb.addEventListener('click', e => { if (e.target === lb || e.target.classList.contains('lb-stage')) closeLb(); });
      img.addEventListener('click', e => {
        const r = img.getBoundingClientRect();
        const fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
        const zoomed = lb.classList.toggle('zoom');
        hint.textContent = zoomed ? `${VERB} per ridurre` : `${VERB} la foto per ingrandire`;
        if (zoomed) requestAnimationFrame(() => {      // centro lo zoom sul punto toccato
          lb.scrollLeft = fx * img.clientWidth - innerWidth / 2;
          lb.scrollTop = fy * img.clientHeight - innerHeight / 2;
        });
      });
      addEventListener('keydown', e => { if (e.key === 'Escape' && lb.classList.contains('on')) closeLb(); });
    }
    const img = $('img', lb);
    if (img.getAttribute('src') !== full) { img.removeAttribute('srcset'); img.src = full; }
    lb.classList.toggle('light', !!(mainBox && mainBox.classList.contains('is-cut')));
    lb.classList.remove('zoom');
    $('.lb-hint', lb).textContent = `${VERB} la foto per ingrandire`;
    lb.scrollTop = 0; lb.scrollLeft = 0;
    lb.classList.add('on');
    document.body.classList.add('locked');
  }
  if (main) main.addEventListener('click', openLb);

  const sticky = $('.sticky-buy');
  if (sticky) {
    document.body.classList.add('has-sticky');
    const trig = $('.buy [data-add]');
    if (trig) new IntersectionObserver(es => es.forEach(e => sticky.classList.toggle('on', !e.isIntersecting)))
      .observe(trig);
  }

  /* ---------------------------------------------------------------- swipe: chiudi il carrello */
  if (drawer && !fine) {
    let x0 = null, y0 = 0, dx = 0, axis = null;
    drawer.addEventListener('touchstart', e => {
      if ($('.d-body').scrollWidth > $('.d-body').clientWidth) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; axis = null;
    }, { passive: true });
    drawer.addEventListener('touchmove', e => {
      if (x0 === null) return;
      const mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
      if (!axis) {
        if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (axis === 'x') drawer.classList.add('drag');
      }
      if (axis !== 'x') return;
      dx = Math.max(0, mx);
      drawer.style.transform = `translateX(${dx}px)`;
    }, { passive: true });
    drawer.addEventListener('touchend', () => {
      drawer.classList.remove('drag');
      drawer.style.transform = '';
      if (axis === 'x' && dx > 90) close();
      x0 = null; axis = null;
    });
  }


  /* ---------------------------------------------------------------- CONSEGNA STIMATA */
  // "Ordina entro le 14:30 → a casa entro giovedì 11 settembre"
  const GIORNI = ['domenica','lunedì','martedì','mercoledì','giovedì','venerdì','sabato'];
  const MESI = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
  function deliveryInfo() {
    const now = new Date();
    const cut = new Date(now); cut.setHours(14, 30, 0, 0);
    const inTime = now < cut;
    const d = new Date(now);
    if (!inTime) d.setDate(d.getDate() + 1);
    let added = 0;                       // +3 giorni lavorativi di trasporto
    while (added < 3) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w && w !== 6) added++; }
    return { inTime, txt: `${GIORNI[d.getDay()]} ${d.getDate()} ${MESI[d.getMonth()]}` };
  }
  function paintDelivery() {
    const { inTime, txt } = deliveryInfo();
    $$('[data-deliv]').forEach(el => {
      el.innerHTML = '<span class="dot"></span><span>' +
        (inTime ? 'Ordina entro le 14:30: ' : 'Spedizione domani: ') + 'a casa entro <b>' + txt + '</b></span>';
    });
  }
  paintDelivery();

  /* ---------------------------------------------------------------- QUICK-BUY SHEET */
  const sheet = $('.sheet');
  let sItem = null;
  const sheetOpen = () => { sheet.classList.add('on'); sheet.setAttribute('aria-hidden', 'false'); document.body.classList.add('locked'); };
  const sheetClose = () => { sheet.classList.remove('on'); sheet.setAttribute('aria-hidden', 'true'); document.body.classList.remove('locked'); };

  function paintSheet() {
    const pic = (sItem.imgs && sItem.imgs[sItem.variant]) || sItem.img;
    if ($('.sheet-head img').getAttribute('src') !== pic) $('.sheet-head img').src = pic;
    $('.s-sub').textContent = sItem.sub;
    $('.s-name').textContent = sItem.name;
    const r3 = sItem.price / 3, rata = Number.isInteger(r3) ? euro(r3) : r3.toFixed(2).replace('.', ',') + ' €';
    $('.s-price').innerHTML = euro(sItem.price) + '<em>oppure 3 rate da ' + rata + ' con Klarna</em>';
    $('.s-qty').textContent = sItem.qty;
    const wrap = $('.s-colors-wrap');
    wrap.hidden = sItem.colors.length < 2;
    $('.s-col-label').textContent = sItem.variant || '';
    $('.s-colors').innerHTML = sItem.colors.map(c =>
      `<button data-col="${c}" class="${c === sItem.variant ? 'on' : ''}"><span class="dot" style="width:12px;height:12px;border-radius:50%;background:${(sItem.sw && sItem.sw[c]) || SW[c] || '#888'};box-shadow:none"></span>${c}</button>`).join('');
  }
  const SW = { 'Nero': '#1B1B1F', 'Rosa': '#C99AA0', 'Verde': '#5C6B4E', 'Viola': '#6E5A7A',
               'Grigio': '#B9BCC2', 'Marrone Chiaro': '#B99C7C', 'Bianco': '#EFEFEF' };

  if (sheet) {
    $$('[data-sheet-close]').forEach(b => b.addEventListener('click', sheetClose));
    sheet.addEventListener('click', e => { if (e.target === sheet) sheetClose(); });
    $('.s-colors').addEventListener('click', e => {
      const b = e.target.closest('[data-col]'); if (!b) return;
      sItem.variant = b.dataset.col; paintSheet();
    });
    $('[data-s-inc]').addEventListener('click', () => { sItem.qty++; paintSheet(); });
    $('[data-s-dec]').addEventListener('click', () => { if (sItem.qty > 1) sItem.qty--; paintSheet(); });
    $('[data-sheet-add]').addEventListener('click', () => {
      sItem.img = (sItem.imgs && sItem.imgs[sItem.variant]) || sItem.img;
      addToCart(sItem, sItem.qty);
      sheetClose(); open(); toast('Aggiunto al carrello');
    });
  }

  /* ---------------------------------------------------------------- QUIZ */
  const quiz = $('[data-quiz]');
  if (quiz) {
    const PERCHE = {
      'bicy-for-everyone': 'Il miglior equilibrio tra prezzo, comfort e versatilità: fat bike con freni idraulici.',
      'bicy-elegante': 'Design curato, tre colori e doppio antifurto: si fa notare senza rinunciare alla sostanza.',
      'bicy-limited-edition-light-brown-2-seater-e-bike': 'Due posti, doppia sospensione e sblocco NFC in una serie limitata.',
      'bicy-cross-e-bike-2-posti': 'Due posti con anima sportiva: doppia sospensione e freni idraulici per lo sterrato.',
      'bicy-sport': 'Compatta e agile, entra ovunque: la più facile da guidare e da parcheggiare.',
      'bicy-vita': 'Comfort e portapacchi integrato: la compagna di tutti i giorni.',
      'bicy-s20-pro': 'Due posti in versione Pro: doppio ammortizzatore posteriore, sella lunga e borsa telaio di serie.',
      'bicy-v20-limited-pro': 'La fat bike classica al livello Pro: doppia sospensione, sella lunga, finiture total black.',
    };
    const score = {}, steps = $$('.q-step', quiz), bar = $('.q-bar i', quiz), res = $('.q-res', quiz);
    let step = 0;
    quiz.addEventListener('click', e => {
      const b = e.target.closest('.q-opts button'); if (!b) return;
      (b.dataset.score || '').split(',').forEach(p => {
        const [k, v] = p.split(':'); if (k) score[k] = (score[k] || 0) + (+v || 0);
      });
      steps[step].hidden = true;
      step++;
      bar.style.width = Math.min(100, (step + 1) / steps.length * 100) + '%';
      if (step < steps.length) { steps[step].hidden = false; return; }
      // vincitore
      const slug = Object.keys(score).sort((a, c) => score[c] - score[a])[0] || 'bicy-for-everyone';
      const card = $(`.card[data-href="/products/${slug}"]`);
      if (!card) { location.href = `/products/${slug}`; return; }
      const d = card.dataset;
      const old = card.querySelector('.card-price s');
      res.innerHTML = `
        <div class="qr-top">
          <img src="${d.img}" alt="${d.name}">
          <div>
            <span class="qr-k">La tua Bicy</span>
            <h3>${d.name}</h3>
            <div class="qr-p">${euro(+d.price)}${old ? '<s>' + old.textContent + '</s>' : ''}</div>
          </div>
        </div>
        <p class="qr-why">${PERCHE[slug] || ''}</p>
        <div class="qr-act">
          <button class="btn btn-volt" data-add="${d.id}" data-name="${d.name}" data-price="${d.price}"
            data-img="${d.img}" data-variant="${(d.colors || '').split('|')[0] || ''}"><span>Aggiungi al carrello</span></button>
          <a class="btn" href="${d.href}"><span>Vedi la scheda</span></a>
        </div>
        <button class="q-again" type="button">Rifai il test</button>`;
      res.hidden = false;
      bar.style.width = '100%';
      res.querySelector('.q-again').addEventListener('click', () => {
        Object.keys(score).forEach(k => delete score[k]);
        step = 0; res.hidden = true; steps.forEach((s, i) => s.hidden = i !== 0);
        bar.style.width = (1 / steps.length * 100) + '%';
      });
    });
  }

  /* ---------------------------------------------------------------- UPSELL CARRELLO */
  // var (non let): render() del carrello può chiamare paintUpsell prima di questa riga
  try { UPSELL = JSON.parse($('#upsell').textContent); } catch (e) {}
  function paintUpsell() {
    const box = $('.d-up'); if (!box || !Array.isArray(UPSELL)) return;
    const hs = cart.map(i => String(i.handle));
    const list = UPSELL.filter(u => !hs.includes(String(u.handle))).slice(0, 3);
    box.hidden = !cart.length || !list.length;
    const wrap = $('.d-up-list', box);
    const have = new Map([...wrap.children].map(c => [c.dataset.id, c]));
    list.forEach((u, idx) => {
      let el = have.get(String(u.id));
      if (el) have.delete(String(u.id));
      else {
        el = document.createElement('div');
        el.className = 'd-up-row';
        el.dataset.id = u.id;
        el.innerHTML = `
        <img src="${u.img}" alt="" loading="lazy">
        <div><b>${u.name}</b><span>${euro(u.price)}</span></div>
        <button data-up="${u.id}" aria-label="Aggiungi ${u.name}">+</button>`;
      }
      if (wrap.children[idx] !== el) wrap.insertBefore(el, wrap.children[idx] || null);
    });
    have.forEach(el => { el.classList.add('out'); setTimeout(() => el.remove(), 220); });
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-up]'); if (!b) return;
    const u = UPSELL.find(x => String(x.id) === b.dataset.up);
    if (!u || b.disabled) return;
    b.disabled = true;
    Promise.resolve(addToCart({ id: '', handle: u.handle, name: u.name, price: u.price, img: u.img, variant: '' }, 1))
      .then(() => toast('Aggiunto')).finally(() => { b.disabled = false; });
  });

  /* ---------------------------------------------------------------- GALLERIA SHOWROOM */
  // tocco su una foto: schermo intero con frecce, swipe, Esc e frecce della tastiera
  $$('[data-sgal]').forEach(sgal => {
    const items = $$('.sg-item', sgal);
    const ico = d => `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="${d}"/></svg>`;
    const box = document.createElement('div');
    box.className = 'sglb'; box.hidden = true;
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Foto dello showroom');
    box.innerHTML = '<img alt="" decoding="async">' +
      `<button class="sg-x" type="button" aria-label="Chiudi">${ico('M6 6l12 12M18 6 6 18')}</button>` +
      `<button class="sg-prev" type="button" aria-label="Foto precedente">${ico('M15 6l-6 6 6 6')}</button>` +
      `<button class="sg-next" type="button" aria-label="Foto successiva">${ico('M9 6l6 6-6 6')}</button>` +
      '<span class="sg-n" aria-live="polite"></span>';
    document.body.appendChild(box);
    const big = $('img', box), num = $('.sg-n', box);
    let cur = 0, back = null;
    const show = i => {
      cur = (i + items.length) % items.length;
      const it = items[cur];
      big.src = it.dataset.full; big.alt = $('img', it).alt;
      num.textContent = `${cur + 1} / ${items.length}`;
      [-1, 1].forEach(d => { const pre = new Image(); pre.src = items[(cur + d + items.length) % items.length].dataset.full; });
    };
    const openG = i => {
      back = document.activeElement; show(i);
      box.hidden = false; requestAnimationFrame(() => box.classList.add('on'));
      document.body.classList.add('locked'); $('.sg-x', box).focus();
    };
    const closeG = () => {
      box.classList.remove('on'); box.hidden = true;
      document.body.classList.remove('locked'); if (back) back.focus();
    };
    items.forEach((it, i) => it.addEventListener('click', () => openG(i)));
    $('.sg-x', box).addEventListener('click', closeG);
    $('.sg-prev', box).addEventListener('click', e => { e.stopPropagation(); show(cur - 1); });
    $('.sg-next', box).addEventListener('click', e => { e.stopPropagation(); show(cur + 1); });
    box.addEventListener('click', e => { if (e.target === box) closeG(); });
    addEventListener('keydown', e => {
      if (box.hidden) return;
      if (e.key === 'Escape') closeG();
      else if (e.key === 'ArrowRight') show(cur + 1);
      else if (e.key === 'ArrowLeft') show(cur - 1);
    });
    let gx = null, gy = 0;
    box.addEventListener('touchstart', e => { if (e.touches.length !== 1) { gx = null; return; } gx = e.touches[0].clientX; gy = e.touches[0].clientY; }, { passive: true });
    box.addEventListener('touchend', e => {
      if (gx === null) return;
      const t = e.changedTouches[0], dx = t.clientX - gx, dy = t.clientY - gy; gx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) show(dx < 0 ? cur + 1 : cur - 1);
    }, { passive: true });
  });

  /* ---------------------------------------------------------------- CAROSELLI */
  // frecce (desktop), indicatore di posizione animato e blocco dell'asse su touch
  $$('.hscroll').forEach(hs => {
    const wrap = document.createElement('div');
    wrap.className = 'hs-wrap';
    hs.parentNode.insertBefore(wrap, hs);
    wrap.appendChild(hs);

    const items = () => [...hs.children].filter(c => c.style.display !== 'none');
    const stepW = () => {
      const it = items();
      if (it.length < 2) return it[0] ? it[0].getBoundingClientRect().width : 300;
      return it[1].offsetLeft - it[0].offsetLeft;
    };

    const arrow = (dir, d) => {
      const b = document.createElement('button');
      b.className = 'hs-nav hs-' + dir;
      b.type = 'button';
      b.setAttribute('aria-label', dir === 'prev' ? 'Indietro' : 'Avanti');
      b.innerHTML = `<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="${d}"/></svg>`;
      b.addEventListener('click', () => hs.scrollBy({ left: dir === 'prev' ? -stepW() : stepW(), behavior: 'smooth' }));
      wrap.appendChild(b);
      return b;
    };
    const prev = arrow('prev', 'M15 6l-6 6 6 6'), next = arrow('next', 'M9 6l6 6-6 6');

    // piede: contatore + puntini + barra di avanzamento
    const foot = document.createElement('div');
    foot.className = 'hs-foot';
    foot.innerHTML = '<span class="hs-count"><b>1</b><i>/</i><em>1</em></span>' +
                     '<div class="hs-dots" role="tablist"></div>' +
                     '<div class="hs-rail"><i></i></div>';
    wrap.appendChild(foot);
    const cNow = $('b', foot), cTot = $('em', foot), dots = $('.hs-dots', foot), rail = $('.hs-rail i', foot);

    function buildDots() {
      const n = items().length;
      const vis = Math.max(1, Math.floor((hs.clientWidth + 8) / Math.max(1, stepW())));
      const reach = Math.max(1, n - vis + 1);          // posizioni davvero raggiungibili
      cTot.textContent = reach;
      dots.innerHTML = '';
      items().slice(0, reach).forEach((el, i) => {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'hs-dot';
        d.setAttribute('aria-label', 'Vai all\'elemento ' + (i + 1));
        d.addEventListener('click', () => hs.scrollTo({ left: el.offsetLeft - hs.offsetLeft, behavior: 'smooth' }));
        dots.appendChild(d);
      });
    }
    buildDots();

    let ticking = false;
    function sync() {
      ticking = false;
      const max = hs.scrollWidth - hs.clientWidth;
      const it = items();
      foot.style.display = max < 4 ? 'none' : '';
      prev.disabled = hs.scrollLeft < 4;
      next.disabled = hs.scrollLeft > max - 4;
      if (max < 4) return;
      const nd = dots.children.length || 1;
      const idx = hs.scrollLeft >= max - 4 ? nd - 1 : Math.min(nd - 1, Math.round(hs.scrollLeft / stepW()));   // a fine corsa: ultimo puntino
      cNow.textContent = idx + 1;
      [...dots.children].forEach((d, i) => d.classList.toggle('on', i === idx));
    }
    hs.addEventListener('scroll', () => {
      if (document.hidden) return sync();
      if (!ticking) { ticking = true; requestAnimationFrame(sync); }
    }, { passive: true });
    addEventListener('resize', () => { buildDots(); sync(); });
    hs.__hsSync = () => { buildDots(); sync(); };     // richiamato dai filtri
    sync();

    // touch: scorrimento nativo del browser (asse bloccato dal sistema, inerzia nativa, nessuno snap)
  });

  /* ---------------------------------------------------------------- CONFRONTA MODELLI */
  // "duello": intestazione fissa con i modelli scelti, valori numerici a barre,
  // vincitore evidenziato. Si cambia modello toccando la sua colonna.
  const ctPicks = $('[data-ct-picks]'), ctOut = $('[data-ct-out]'), ctHint = $('[data-ct-hint]');
  if (ctPicks) {
    let BIKES = [];
    try { BIKES = JSON.parse($('#bikes-data').textContent); } catch (e) {}

    const BARS = [
      { k: 'Autonomia', unit: 'km', better: 'max' },
    ];
    const ROWS = ['Motore', 'Batteria', 'Freni', 'Sospensioni', 'Posti', 'Colori'];   // motore: 250 W su tutti, niente barra
    const num = s => parseInt(String(s).replace(/[^\d]/g, ''), 10) || 0;
    // le barre sono in scala sul massimo di tutta la gamma: si vede dove sta ogni modello, non solo chi vince
    const RANGE = {};
    BARS.forEach(b => { const vs = BIKES.map(x => num(x.specs[b.k])).filter(Boolean); RANGE[b.k] = Math.max(...vs) || 1; });
    const barCols = (list, bar) => {
      const vals = list.map(b => num(b.specs[bar.k]));
      const mx = Math.max(...vals), mn = Math.min(...vals), tie = mx === mn;
      return list.map((b, i) => {
        const v = vals[i], win = !tie && v === mx;
        return { val: b.specs[bar.k], w: Math.max(6, v / RANGE[bar.k] * 100), cls: win ? 'win' : tie ? 'tie' : '',
                 delta: tie ? 'pari' : win ? `+${v - mn} ${bar.unit}` : '' };
      });
    };
    const labOf = bar => `${bar.k}<em>max in gamma ${RANGE[bar.k]} ${bar.unit}</em>`;
    const slots = () => (innerWidth < 760 ? 2 : 3);
    let sel = [];
    let picking = -1;                                  // colonna in attesa di scelta

    function fill() {
      const n = slots();
      sel = sel.slice(0, n);
      while (sel.length < n) {
        const next = BIKES.find(b => !sel.includes(b.slug));
        if (!next) break;
        sel.push(next.slug);
      }
    }

    const nameOf = b => b.name.replace('Bicy ', '');
    const paintPicks = () => {
      ctPicks.hidden = picking < 0;
      $$('.ct-pick', ctPicks).forEach(p => {
        p.classList.toggle('on', picking > -1 && sel[picking] === p.dataset.slug);
        p.classList.toggle('used', sel.includes(p.dataset.slug));
      });
    };
    const paintPicking = () => $$('.ct2-slot', ctOut).forEach((s, i) => s.classList.toggle('picking', picking === i));

    function build(list, maxOf) {
      return `
        <div class="ct2">
          <div class="ct2-head">
            ${list.map((b, i) => `
              <button class="ct2-slot" type="button" data-slot="${i}" data-slug="${b.slug}">
                <img src="${b.img}" alt="" decoding="async">
                <span class="ct2-txt"><b>${nameOf(b)}</b><span class="ct2-price">${euro(b.price)}</span></span>
                <span class="ct2-swap">Cambia</span>
              </button>`).join('')}
          </div>
          ${BARS.map(bar => `
            <div class="ct2-block" data-bar="${bar.k}">
              <span class="ct2-lab">${labOf(bar)}</span>
              <div class="ct2-bars">
                ${barCols(list, bar).map(c => `<div class="ct2-bar ${c.cls}">
                  <span class="ct2-top"><span class="ct2-val">${c.val}</span><span class="ct2-delta${c.cls === 'tie' ? ' tie' : ''}">${c.delta}</span></span>
                  <span class="ct2-track"><i style="width:${c.w}%"></i></span>
                </div>`).join('')}
              </div>
            </div>`).join('')}
          ${ROWS.map(l => `
            <div class="ct2-block" data-row="${l}">
              <span class="ct2-lab">${l}</span>
              <div class="ct2-vals">${list.map(b => `<span class="ct2-txt">${b.specs[l] || '—'}</span>`).join('')}</div>
            </div>`).join('')}
          <div class="ct2-block ct2-cta">
            ${list.map(b => `<a class="btn btn-sm btn-volt" href="${b.href}"><span>Scopri</span></a>`).join('')}
          </div>
        </div>`;
    }

    // aggiornamento in posto: si toccano solo i valori cambiati, le foto non vengono ricaricate
    function patch(root, list, maxOf) {
      $$('.ct2-slot', root).forEach((s, i) => {
        const b = list[i]; if (!b || s.dataset.slug === b.slug) return;
        s.dataset.slug = b.slug;
        $('img', s).src = b.img; $('b', s).textContent = nameOf(b); $('.ct2-price', s).textContent = euro(b.price);
      });
      BARS.forEach(bar => {
        const cols = barCols(list, bar);
        $$(`[data-bar="${bar.k}"] .ct2-bar`, root).forEach((el, i) => {
          const c = cols[i]; if (!c) return;
          el.classList.toggle('win', c.cls === 'win'); el.classList.toggle('tie', c.cls === 'tie');
          $('.ct2-val', el).textContent = c.val;
          const d = $('.ct2-delta', el); d.textContent = c.delta; d.classList.toggle('tie', c.cls === 'tie');
          $('.ct2-track i', el).style.width = c.w + '%';
        });
      });
      ROWS.forEach(l => $$(`[data-row="${l}"] .ct2-txt`, root).forEach((el, i) => { if (list[i]) el.textContent = list[i].specs[l] || '—'; }));
      $$('.ct2-cta .btn', root).forEach((a, i) => { if (list[i]) a.href = list[i].href; });
    }

    function render() {
      const list = sel.map(s => BIKES.find(b => b.slug === s)).filter(Boolean);
      ctHint.textContent = 'Tocca un modello per cambiarlo';
      ctOut.classList.add('on');
      ctOut.style.setProperty('--cols', list.length);
      const maxOf = k => Math.max(...list.map(b => num(b.specs[k])));
      const root = $('.ct2', ctOut);
      if (root && $$('.ct2-slot', root).length === list.length) patch(root, list, maxOf);
      else ctOut.innerHTML = build(list, maxOf);
      paintPicking();
      paintPicks();
    }

    ctPicks.innerHTML = BIKES.map(b => `
      <button class="ct-pick" type="button" data-slug="${b.slug}">
        <img src="${b.img}" alt="" loading="lazy" decoding="async">
        <span>${nameOf(b)}</span>
      </button>`).join('');

    ctOut.addEventListener('click', e => {
      const s = e.target.closest('.ct2-slot'); if (!s) return;
      picking = picking === +s.dataset.slot ? -1 : +s.dataset.slot;
      paintPicking(); paintPicks();                    // solo classi: nessuna ricostruzione
      if (picking > -1) {
        const r = ctPicks.getBoundingClientRect(), top = headH() + 12;
        if (r.top < top || r.bottom > innerHeight) scrollTo({ top: scrollY + r.top - top, behavior: 'smooth' });
      }
    });

    ctPicks.addEventListener('click', e => {
      const b = e.target.closest('.ct-pick'); if (!b || picking < 0) return;
      const slug = b.dataset.slug;
      const other = sel.indexOf(slug);
      if (other > -1) sel[other] = sel[picking];      // scambio, niente doppioni
      sel[picking] = slug;
      picking = -1;
      render();
    });

    addEventListener('resize', () => { fill(); render(); });
    fill(); render();
  }

  /* ---------------------------------------------------------------- pagina FAQ: ricerca + indice */
  const fp = $('.faq-page');
  if (fp) {
    const q = $('[data-faq-search]', fp), groups = $$('.faq-group', fp), items = $$('.faq-group details', fp);
    const cnt = $('[data-faq-count]', fp), links = $$('.faq-side a[href^="#"], .faq-cats a', fp);
    const norm = s => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    items.forEach(d => { d.dataset.t = norm(d.textContent); });
    const run = () => {
      const v = norm(q.value.trim());
      if (v.length < 2) {
        fp.classList.remove('searching', 'none');
        items.forEach(d => { d.classList.remove('hid'); if (d.dataset.auto) { d.open = false; delete d.dataset.auto; } });
        groups.forEach(g => g.classList.remove('hid'));
        if (cnt) cnt.textContent = items.length; return;
      }
      let n = 0;
      groups.forEach(g => {
        let k = 0;
        $$('details', g).forEach(d => {
          const ok = d.dataset.t.includes(v); d.classList.toggle('hid', !ok);
          if (ok) { k++; if (!d.open) { d.open = true; d.dataset.auto = '1'; } }
        });
        g.classList.toggle('hid', !k); n += k;
      });
      fp.classList.add('searching'); fp.classList.toggle('none', !n);
      if (cnt) cnt.textContent = n;
    };
    q.addEventListener('input', run);
    /* indice: evidenzia l'argomento in vista */
    const gio = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) links.forEach(a => a.classList.toggle('on', a.getAttribute('href') === '#' + e.target.id));
    }), { rootMargin: '-25% 0px -65% 0px' });
    groups.forEach(g => gio.observe(g));
    /* arrivo con #argomento: apri la prima domanda del gruppo */
    let tg = null;
    try { const g = location.hash && document.getElementById(decodeURIComponent(location.hash.slice(1))); tg = g && g.querySelector('details'); } catch (e) {}
    if (tg) tg.open = true;
  }

  /* ---------------------------------------------------------------- newsletter */
  $$('form[data-news]').forEach(f => f.addEventListener('submit', e => {
    e.preventDefault(); f.reset(); toast('Iscrizione registrata');
  }));
})();

/* ---------------------------------------------------------------- COOKIE
   Barra cookie: tecnici sempre, Google (mappa e caratteri) solo col consenso. */
(function () {
  const KEY = 'bicy-cookie';
  const $1 = s => document.querySelector(s);
  const get = () => { try { return localStorage.getItem(KEY); } catch (e) { return 'all'; } };
  const set = v => { try { localStorage.setItem(KEY, v); } catch (e) {} };

  function loadMaps() {
    document.querySelectorAll('iframe[data-ck-src]').forEach(f => {
      f.src = f.dataset.ckSrc;
      f.removeAttribute('data-ck-src');
      const ph = f.previousElementSibling;
      if (ph && ph.classList.contains('ck-map')) ph.remove();
      f.hidden = false;
    });
  }

  function blockMaps() {
    document.querySelectorAll('iframe[data-ck-src]').forEach(f => {
      if (f.previousElementSibling && f.previousElementSibling.classList.contains('ck-map')) return;
      f.hidden = true;
      const ph = document.createElement('div');
      ph.className = 'ck-map';
      ph.innerHTML = '<p>La mappa è fornita da Google e si carica solo con il tuo consenso.</p>' +
        '<button class="btn btn-volt btn-sm" type="button"><span>Mostra la mappa</span></button>';
      ph.querySelector('button').addEventListener('click', loadMaps);
      f.parentNode.insertBefore(ph, f);
    });
  }

  function start() {
    const bar = $1('[data-ck]');
    const choice = get();
    if (choice === 'all') { loadMaps(); if (bar) bar.remove(); return; }
    if (choice === 'necessary') { blockMaps(); if (bar) bar.remove(); return; }
    blockMaps();
    if (!bar) return;
    bar.hidden = false;
    document.body.classList.add('ck-on');
    const h = () => document.documentElement.style.setProperty('--ck-h', bar.offsetHeight + 'px');
    requestAnimationFrame(h); addEventListener('resize', h);
    const close = v => {
      set(v); bar.hidden = true;
      document.body.classList.remove('ck-on');
      document.documentElement.style.removeProperty('--ck-h');
      setTimeout(() => bar.remove(), 200);
    };
    const yes = bar.querySelector('[data-ck-yes]'), no = bar.querySelector('[data-ck-no]');
    if (yes) yes.addEventListener('click', () => { close('all'); loadMaps(); });
    if (no) no.addEventListener('click', () => close('necessary'));
  }

  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', start);
  else start();
})();
